export const addNotification = (text) => {
	const updateMsg = `<div class="browser-fail"><p>${text}</p></div>`;
	document.getElementById("browserFail").innerHTML = updateMsg;
};

export const removeNotification = () => {
	document.getElementById("browserFail").innerHTML = "";
};
